<template>
  <div class="d-group text-dark">
    <label class="d-label" v-if="isShowLabel">{{ i18n['absence_reason'] }}</label>
    <div class="choose-subject">
      <div class="choose-subject__spinner" v-if="isLoadingSubjects">
        <div class="do-spinner"></div>
      </div>
      <dSelect
        :items="sortedSubjects"
        v-else
        :resetCounter="resetCounter"
        :multiple="false"
        :placeholder="$t('vue2.common.search')"
        :itemSpaceBetween="true"
        :itemsSelected="selectedSubjectArr"
        :isShowRemoveButton="false"
        @enter="isCreateAbsenceReason = true"
        @update="setSubject"
        @searchText="setTheSearchText"
        @onSearchTextDebounced="onSearchTextDebounced"
        @close="onCloseDSelect"
      >
        <template v-for="(item, index) in sortedSubjects" v-slot:test="slotProps">
          <div class="choose-subject__event_type">
            {{ slotProps.item.vSubjectType }}
          </div>
        </template>
      </dSelect>
    </div>
  </div>
</template>

<script>
import dSelect from '../DSelect/DSelect.vue'
import moment from 'moment'
import docendo from '../../docendo'
import { mapGetters } from 'vuex'

const I18N = {
  da: {
    absence_reason: 'Fraværsårsag'
  },
  en: {
    absence_reason: 'Absence reason'
  },
  nb: {
    absence_reason: 'Fraværsårsak'
  }
}

export default {
  components: { dSelect },
  props: {
    calendarId: {
      default: () => 309496
    },
    date: {
      default: () => moment()
    },
    selectedSubject: {
      default: null
    },
    resetCounter: {
      default: 0
    },
    isShowLabel: {
      default: true,
      type: Boolean
    }
  },
  data () {
    return {
      isLoadingSubjects: false,
      subjects: [],
      isSubmitting: false,
      theSearchText: '',
      theNewSubject: null,
      isShowCreateSubjectButton: false,
      theNewlyCreatedSubject: null,
      isCreateAbsenceReason: false,
      startTime: moment().set({ hour: 8, minutes: 0 }),
      endTime: moment().set({ hour: 16, minutes: 0 })
    }
  },
  computed: {
    ...mapGetters([
      'schoolId',
      'locale'
    ]),
    i18n () {
      return I18N[this.locale] || I18N['da']
    },
    filteredSubjects () {
      return this.subjects.filter(subject => subject.can_request)
    },
    selectedSubjectArr () {
      if (!this.selectedSubject) {
        return []
      }
      const filteredSubjects = this.filteredSubjects.filter(subject => subject.id === this.selectedSubject.id)
      return filteredSubjects.length > 0 ? filteredSubjects : []
    },
    sortedSubjects () {
      return this.filteredSubjects
        .map(subject => {
          const translatedSubjectType = this.$t(`vue2.eventTypes.${subject.subject_type}`)
          const vSubjectType = translatedSubjectType === `vue2.eventTypes.${subject.subject_type}`
            ? subject.subject_type
            : translatedSubjectType

          return {
            ...subject,
            vSubjectType
          }
        })
        .sort((a, b) => {
          if (a.name < b.name) return -1
          if (a.name > b.name) return 1
          return 0
        })
    },
    dbEventStart () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.startTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    },
    dbEventEnd () {
      let date = moment(this.date).format('YYYY-MM-DD')
      let time = this.endTime.locale('LT')
      return moment(date).set({
        hour: time.get('hour'),
        minutes: time.get('minutes')
      })
    }
  },
  watch: {
    selectedSubject () {
      this.theNewSubject = null
    },
    calendarId () {
      this.readSubjects()
    },
    theNewlyCreatedSubject () {
      this.readSubjects()
    }
  },
  methods: {
    setDate (date) {
      this.$emit('setDate', date)
    },
    onCloseDSelect () {
      this.isShowCreateSubjectButton = false
    },
    setIsShowCreateSubjectButton () {
      const idx = this.filteredSubjects.findIndex(subject => subject.name === this.theSearchText)
      this.isShowCreateSubjectButton = this.theSearchText.length > 0 && idx < 0
    },
    onSearchTextDebounced () {
      this.setIsShowCreateSubjectButton()
    },
    setTheSearchText (str) {
      this.theSearchText = str
    },
    setSubject (arr) {
      const selectedSubject = arr.length > 0 ? arr[0] : null
      if (!selectedSubject) {
        return
      }
      this.$emit('setSubject', selectedSubject)
    },
    setStartTime (payload) {
      this.startTime = payload
    },
    setEndTime (payload) {
      this.endTime = payload
    },
    readSubjects () {
      this.isLoadingSubjects = true
      docendo.schoolAbsenceSubjectsList(this.schoolId, false, success => {
        this.isLoadingSubjects = false
        this.subjects = success
      }, failure => {
        console.log('something went wrong')
      })
    }
  },
  mounted () {
    this.readSubjects()
    setTimeout(_ => {
      const el = document.querySelector('#d-create-task-for-user .d-select__input-look > input[type="search"]')
      if (el) {
        el.focus()
      }
    }, 400)
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.choose-subject__spinner {
  position: relative;
  pointer-events: none;
  cursor: not-allowed;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding-right: 1rem;
  height: 34px;
  width: 100%;
  border-radius: 4px;
  cursor: text;
  border: 1px solid #edf2f7;
  -webkit-appearance: none !important;
  background: #fff;
  box-shadow: 0 2px 5px -1px rgba(50, 50, 93, .25), 0 1px 3px -1px rgba(0, 0, 0, .3);
}

.choose-subject__spinner:before {
  content: 'Søg eller opret';
  position: absolute;
  top: 0;
  bottom: 0;
  left: 9px;
  line-height: 32px;
  color: #757575;
}


.choose-subject {
  position: relative;
}

.create-new-subject {
  position: absolute;
  top: 0.2rem;
  right: -2.6rem;
}

.d-icon-plus {
  font-size: 13px;
}

.d-icon-plus:before {
  content: '+';
  color: #ffffff;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  width: 14px;
  height: 14px;
  background-color: rgb(162, 163, 166);
  opacity: 0.6;
}

.create-subject-link {
  background-color: var(--blue) !important;
  color: white;
  cursor: pointer;
}

</style>



// WEBPACK FOOTER //
// UserAbsence.vue?44be920e